var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('svg',{attrs:{"width":"100px","height":"100px","viewBox":"-50 -50 100 100"}},[_c('polyline',{ref:"line",attrs:{"id":"load-anim"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }